"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemperatureCard = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _paulWidgetTemperaturePackage = require("paul-widget-temperature-package");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _selectors = require("../../../../redux/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TemperatureCard = _ref => {
  let {
    thingPDIDDevice = null,
    position = [3, 10, -3.5]
  } = _ref;
  const selectedPoint = (0, _reactRedux.useSelector)(_selectors.getSelectedPoint);
  const [showCard, setShowCard] = (0, _react.useState)(false);
  const isSelected = thingPDIDDevice === (selectedPoint === null || selectedPoint === void 0 ? void 0 : selectedPoint.thingPDIDDevice);
  (0, _react.useEffect)(() => {
    if (!isSelected) setTimeout(() => setShowCard(false), 200);else setShowCard(true);
  }, [isSelected]);
  return (0, _react.useMemo)(() => showCard ? /*#__PURE__*/_react.default.createElement(_drei.Html, {
    className: "clickable-area",
    position: position,
    center: true
    // rotation={[0,Math.PI / 2, 0]}
    // scale={.8}
    // transform
    // occlude
    ,
    style: {
      transition: 'all 0.5s',
      opacity: isSelected ? 1 : 0,
      pointerEvents: isSelected ? 'auto' : 'none',
      transform: "scale(".concat(isSelected ? 1 : 0.5, ")"),
      zIndex: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: _paulCorePackage.store
  }, /*#__PURE__*/_react.default.createElement(_paulWidgetTemperaturePackage.DeviceCard, {
    thingPDIDDevice: thingPDIDDevice,
    inSwiper: true
  }))) : null, [thingPDIDDevice, isSelected, showCard, position]);
};
exports.TemperatureCard = TemperatureCard;